import { Flex, Loader } from "@mantine/core";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useState } from 'react';

function ImageObserved(model: { className?: string, style?: object, dark?: boolean, imgStyle?: object, width: string, height: string, src?: string, objectFit?: string }) {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <Flex
      p={model.dark ? "xs" : undefined}
      bg={model.dark ? "rgba(16, 16, 16, 1)" : 'rgba(16, 16, 16, 1)'}
      align={'center'}
      justify={'center'}
      className={model.className}
      style={{
        borderRadius: model.dark ? '4px' : undefined,
        ...(model.style ?? {})
      }}
      w="100%"
      pos="relative"
    >
      {isLoading && (
        <Flex pos="absolute" align="center" justify="center" w="100%" h="100%">
          <Loader size="md" color="gray.4" />
        </Flex>
      )}
      <LazyLoadImage
        alt={'image'}
        threshold={400}
        height={model.height}
        src={model.src}
        width={model.width}
        effect="opacity"
        style={{ objectFit : model.objectFit ? model.objectFit : "contain"}}
        onLoad={() => setIsLoading(false)}
        // className="lazy-load-image"
      
        wrapperProps={{
          // If you need to, you can tweak the effect transition using the wrapper style.
          style: {
            objectFit: model.objectFit ? model.objectFit : "contain",
            ...(model.imgStyle ?? {})
          },
        }}
      />
    </Flex>
  )
}

export default ImageObserved